import { render, staticRenderFns } from "./RatingCategoriesPointsEditor.vue?vue&type=template&id=f4d9e07c&scoped=true&"
import script from "./RatingCategoriesPointsEditor.vue?vue&type=script&lang=js&"
export * from "./RatingCategoriesPointsEditor.vue?vue&type=script&lang=js&"
import style0 from "./RatingCategoriesPointsEditor.vue?vue&type=style&index=0&id=f4d9e07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d9e07c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
